module.exports = require('./kmeans');


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-kmeans/src/index.js
 ** module id = 127
 ** module chunks = 0
 **/